import React, { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import LoginHeader from './components/LoginHeader';
import LoginForm from './components/LoginForm';
import SecurityBadges from './components/SecurityBadges';

const LoginPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loading } = useAuth();

  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <>
      <Helmet>
        <title>Sign In - Wilcart CRM</title>
        <meta name="description" content="Sign in to your Wilcart CRM workspace to manage your sales pipeline and customer relationships." />
      </Helmet>
      <div className="min-h-screen bg-background flex items-center justify-center p-4">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5 pointer-events-none" />

        {/* Decorative blobs */}
        <div className="absolute top-10 left-10 w-32 h-32 bg-primary/10 rounded-full blur-2xl pointer-events-none" />
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-secondary/10 rounded-full blur-2xl pointer-events-none" />
        <div className="absolute top-1/2 left-20 w-20 h-20 bg-primary/5 rounded-full blur-xl pointer-events-none" />

        <div className="relative w-full max-w-md">
          <div className="bg-card border border-border rounded-2xl shadow-elevation-2 p-6 sm:p-8">
            <LoginHeader />
            <LoginForm />
            <SecurityBadges />
          </div>
          <div className="mt-6 text-center space-y-2">
            <p className="text-sm text-muted-foreground">
              Don't have an account?{' '}
              <Link to="/signup" className="text-primary hover:text-primary/80 font-semibold">
                Create workspace
              </Link>
            </p>
            <p className="text-xs text-muted-foreground">
              © {new Date()?.getFullYear()} Wilcart. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginPage;